export class PlanFeatureQuota{
  quota: number;
  featureId : string;
  featureKeyName : string;
  period : 'monthly' | 'yearly' | 'flat';
  constructor(featureKeyName: string, quota: number) {
    this.featureKeyName = featureKeyName
    this.quota = quota;
  }
}
